import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Header from '../components/Header.vue'
import Index from '../components/Index.vue'
import Home from '../components/Home.vue'
import Footer from '../components/Footer.vue'
import Article from '../components/Article.vue'
import Course from '../components/Course.vue'
import CourseDetails from '../components/CourseDetails.vue'
import File from '../components/File.vue'
import ArticleExplain from '../components/ArticleExplain.vue'
import Company from '../components/Company.vue'
import CompanyMemberList from '../components/CompanyMemberList.vue'
import MemberDetails from '../components/MemberDetails.vue'
import ProductDetails from '../components/ProductDetails.vue'
import Search from '../components/Search.vue'
import Magazine from '../components/Magazine.vue'
import Policy from '../components/Policy.vue'
import Fee from '../components/Fee.vue'
import Information from '../components/Information.vue'
import UserHeader from '../components/PersonCenter/UserHeader.vue'
import leftNav from '../components/PersonCenter/LeftNav.vue'
import userInfo from '../components/PersonCenter/UserInfo.vue'
import MyCompany from '../components/PersonCenter/MyCompany.vue'
import MyMessage from '../components/PersonCenter/MyMessage.vue'
import MyMessageDetails from '../components/PersonCenter/MyMessageDetails.vue'
import MyRights from '../components/PersonCenter/MyRights.vue'
import MyCollection from '../components/PersonCenter/MyCollection.vue'
import MyNeed from '../components/PersonCenter/MyNeed.vue'
import MyActivity from '../components/PersonCenter/MyActivity.vue'
import MyQuestionnaire from '../components/PersonCenter/MyQuestionnaire.vue'
import MyFee from '../components/PersonCenter/MyFee.vue'
import UserAgreement from '../components/PersonCenter/UserAgreement.vue'
import Privacy from '../components/PersonCenter/Privacy.vue'
import Introduce from '../components/Introduce/Introduce.vue'
import IntroduceNav from '../components/Introduce/LeftNav.vue'
import InfoDetails from '../components/Introduce/InfoDetails.vue'
import GuideMenu from '../components/Guide/Guide-menu.vue'
import ApplyPerson from '../components/ApplyPerson.vue'
import ApplyCompany from '../components/ApplyCompany.vue'
import Invest from '../components/Invest.vue'
import Order from '../components/Order.vue'
import InvestInfo from '../components/InvestInfo.vue'
import NeedDetails from '../components/NeedDetails.vue'
import Events from '../components/Events.vue'

//懒加载导入组件
// const Login = () => import(/*webpackChunkName:"login" */ '../components/Login.vue')

Vue.use(VueRouter)

  const routes = [
    {
      path:'/',
      name:'/',
      name:'/',
      components:{
        Index:Index,
        Header:Header,
        Footer:Footer,
      },
      // redirect:'/index'     //重定向
    },
    {
      path:'/login',
      components:{
        Header:Header,
        Login:Login,
      },
    },
    {
      path:'/index',
      name:'/',
      components:{
        Index:Index,
        Header:Header,
        Footer:Footer,
      },
      meta:{
        keepAlive:true
      },
      children:[
        // {path:'/index',name:'/',component:Index},
        // {path:'/article/:id',name:'/article',component:Article},
        // {path:'/file/:id',name:'/file',component:File},
        // {path:'/company/:id',name:'/company',component:Company},
        // {path:'/company_member_list/:active',name:'/company_member_list',component:CompanyMemberList},
        // {path:'/member',redirect:'/company_member_list/1',name:'/company_member_list',component:CompanyMemberList},
        // {path:'/member_details/:member_id',name:'/member_details',component:MemberDetails},
        // {path:'/product_details/:id',name:'/product_details',component:ProductDetails},
        // {path:'/search',name:'/search',component:Search},
        // {path:'/information',name:'/information',component:Information},
        // {path:'/policy/:active',name:'/policy',component:Policy},
        // {path:'/policy',name:'/policy',redirect:'/policy/0',component:Policy},
        // {path:'/service',name:'/service',redirect:'/policy/1',component:Policy},
      ]
    },
    //新首页
    {
      path:'/home',
      name:'/',
      components:{
        Home:Home,
        Header:Header,
        Footer:Footer,
      },
      meta:{
        keepAlive:true
      },
    },
    //协会公告、政策文件详情
    {
      path:'/file/:id', 
      components:{
        Header:Header,
        'File':File,
        Footer:Footer
      }
    },
    //文章详情
    {
      path:'/article/:id', 
      components:{
        Header:Header,
        'Article':Article,
        Footer:Footer
      }
    },
    //课程详情Course
    {
      path:'/course/:id', 
      components:{
        Header:Header,
        'Course':Course,
        Footer:Footer
      }
    },
    //课程視頻详情
    {
      path:'/course_details/:course_id/:kpiont_id', 
      components:{
        Header:Header,
        'CourseDetails':CourseDetails,
        Footer:Footer
      }
    },
    //资讯列表
    {
      path:'/information', 
      name:'/information',
      redirect:'/information/0',
      components:{
        Header:Header,
        'Information':Information,
        Footer:Footer
      }
    },
    {
      path:'/information/:active', 
      name:'/information',
      components:{
        Header:Header,
        'Information':Information,
        Footer:Footer
      }
    },
    //大事记列表
    {
      path:'/events/:id', 
      components:{
        Header:Header,
        'Events':Events,
        Footer:Footer
      }
    },
    // 杂志列表
    {
      path:'/magazine', 
      name:'/magazine',
      components:{
        Header:Header,
        'Magazine':Magazine,
        Footer:Footer
      }
    },
    // 会员缴费
    {
      path:'/fee', 
      name:'/fee',
      components:{
        Header:Header,
        'Fee':Fee,
        Footer:Footer
      }
    },
    //政策文件
    {
      path:'/policy', 
      name:'/service',
      redirect:'/policy/0',
      components:{
        Header:Header,
        'Policy':Policy,
        Footer:Footer
      }
    },
    {
      path:'/policy/:active', 
      name:'/service',
      components:{
        Header:Header,
        'Policy':Policy,
        Footer:Footer
      }
    },
    //解讀详情
    {
      path:'/article-explain/:id', 
      components:{
        Header:Header,
        'ArticleExplain':ArticleExplain,
        Footer:Footer
      }
    },
    //协会服务
    {
      path:'/service', 
      name:'/service',
      redirect:'/policy/0',
      components:{
        Header:Header,
        'service':Policy,
        Footer:Footer
      }
    },
    //会员展示
    {
      path:'/member', 
      name:'/member',
      redirect:'/company_member_list/1',
      components:{
        Header:Header,
        'CompanyMemberList':CompanyMemberList,
        Footer:Footer
      }
    },
    //企业列表
    {
      path:'/company_member_list/:active', 
      name:'/member', 
      components:{
        Header:Header,
        'CompanyMemberList':CompanyMemberList,
        Footer:Footer
      }
    },
    //企业详情
    {
      path:'/company/:id', 
      components:{
        Header:Header,
        'Company':Company,
        Footer:Footer
      }
    },
    //企业产品详情
    {
      path:'/product_details/:id', 
      components:{
        Header:Header,
        'ProductDetails':ProductDetails,
        Footer:Footer
      }
    },
    //会员详情
    {
      path:'/member_details/:member_id', 
      components:{
        Header:Header,
        'MemberDetails':MemberDetails,
        Footer:Footer
      }
    },
    //搜索
    {
      path:'/search', 
      components:{
        Header:Header,
        'Search':Search,
        Footer:Footer
      }
    },
    //协会指南
    {
      path:'/guide', 
      name:'/guide', 
      components:{
        Header:Header,
        // 'UserHeader':UserHeader,
        'GuideMenu':GuideMenu,
        // 'userInfo':userInfo,
        Footer:Footer
      }
    },
    //个人中心
    {
      path:'/person_center', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'userInfo':userInfo,
        Footer:Footer
      }
    },
    {
      path:'/my_company', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyCompany':MyCompany,
        Footer:Footer
      }
    },
    {
      path:'/my_message', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyMessage':MyMessage,
        Footer:Footer
      }
    },
    {
      path:'/my_message_details', 
      components:{
        Header:Header,
        'MyMessageDetails':MyMessageDetails,
        Footer:Footer
      }
    },
    {
      path:'/my_collection', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyCollection':MyCollection,
        Footer:Footer
      }
    },
    {
      path:'/my_need', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyNeed':MyNeed,
        Footer:Footer
      }
    },
    
    {
      path:'/my_rights', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyRights':MyRights,
        Footer:Footer
      }
    },
    {
      path:'/my_activity', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyActivity':MyActivity
      }
    },
    {
      path:'/my_questionnaire', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyQuestionnaire':MyQuestionnaire
      }
    },
    {
      path:'/my_fee', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'MyFee':MyFee
      }
    },
    {
      path:'/privacy', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'Privacy':Privacy,
        Footer:Footer
      }
    },
    {
      path:'/user_agreement', 
      components:{
        Header:Header,
        'UserHeader':UserHeader,
        'left':leftNav,
        'UserAgreement':UserAgreement,
        Footer:Footer
      }
    },
    //协会介绍
    {
      path:'/introduce', 
      name:'introduce',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //协会介绍详情
    {
      path:'/infoDetails/:id', 
      name:'infoDetails',
      components:{
        Header:Header,
        'InfoDetails':InfoDetails,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //协会章程regulations
    {
      path:'/regulations', 
      name:'regulations',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //组织架构organization
    {
      path:'/organization', 
      name:'organization',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //协会联谊会
    {
      path:'/fraternity', 
      name:'fraternity',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //协会秘书处
    {
      path:'/secretariat', 
      name:'secretariat',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //协会委员会
    {
      path:'/committee', 
      name:'committee',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //加入協會
    {
      path:'/apply', 
      name:'apply',
      components:{
        Header:Header,
        'Introduce':Introduce,
        'IntroduceNav':IntroduceNav,
        Footer:Footer
      }
    },
    //个人申请入会
    {
      path:'/apply-person', 
      components:{
        Header:Header,
        'ApplyPerson':ApplyPerson,
        Footer:Footer
      }
    },
    //企业申请入会
    {
      path:'/apply-company', 
      components:{
        Header:Header,
        'ApplyCompany':ApplyCompany,
        Footer:Footer
      }
    },
    //項目投資列表
    {
      path:'/Invest', 
      name:'/Invest',
      components:{
        Header:Header,
        'Invest':Invest,
        Footer:Footer
      }
    },
    //訂單訊息列表
    {
      path:'/Order', 
      name:'/Order',
      components:{
        Header:Header,
        'Order':Order,
        Footer:Footer
      }
    },
    //訂單訊息、項目投資详情
    {
      path:'/investInfo/:id', 
      name:'/InvestInfo',
      components:{
        Header:Header,
        'InvestInfo':InvestInfo,
        Footer:Footer
      }
    },
    //需求列表详情
    {
      path:'/need-details/:id', 
      name:'/NeedDetails',
      components:{
        Header:Header,
        'NeedDetails':NeedDetails,
        Footer:Footer
      }
    },
    
    
  ]

const router = new VueRouter({
  mode:'hash',
  routes
})
//挂载路由导航守卫
router.beforeEach((to,from,next) => {
  //to将要访问的路径
  //from代表从哪个路径跳转而来
  //next 是一个函数，表示放行
  //next()放行 next('/login') 强制跳转
  if(to.path === '/person_center'){
    const tokenStr = window.sessionStorage.getItem('token')
    if(!tokenStr) return next('/login')
    next()
  }else{
    return next();
  } 
  // //获取token
  
  
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
